import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-terminal-login-dialog',
  templateUrl: './terminal-login-dialog.component.html',
  styleUrls: ['./terminal-login-dialog.component.scss']
})
export class TerminalLoginDialogComponent implements OnInit, OnDestroy {

  constructor(
    public dialogRef: MatDialogRef<TerminalLoginDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {depName: string, headNodeIp: string},
    private deploymentService: DeploymentService, private env: EnvironmentService,
    private utilityService: UtilityService,
    private _snackBar: MatSnackBar, private spinner: NgxSpinnerService
  ) { }

  terminalLogin: UntypedFormGroup;
  fieldTextType: boolean = true;
  utilityType = this.deploymentService.getProfileInfoFromSubject(this.data?.depName)?.routeViaSynchpc || false;
  isUtilityServiceActive: boolean = this.utilityType ? true : false;
  isFetchingStatus: boolean = false;

  ngOnInit(): void {
    this.terminalLogin= new UntypedFormGroup({
      username: new UntypedFormControl('', [Validators.required]),
      password: new UntypedFormControl('', [Validators.required]),
    });
    this.checkServiceStatus();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.spinner.hide("nodeList");
  }

  checkServiceStatus(){
    if(!this.isUtilityServiceActive){
      this.isFetchingStatus = true;
      this.utilityService.checkIfUtilityServiceActive(this.data.headNodeIp, this.data.depName)
      .pipe(tap(data => {this.isFetchingStatus = false;this.spinner.hide("nodeList");}))
      .subscribe(data => {
        this.isUtilityServiceActive = data;
        if(data == false){
          this._snackBar.open("Utility Service is not active", "Close", {duration: 3000})
        }
      });
    }
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    if(this.terminalLogin.status == 'INVALID' || !this.isUtilityServiceActive){
      this.terminalLogin.markAllAsTouched();
    } else {
      let username = this.terminalLogin.value.username;
      let password = this.terminalLogin.value.password;
      this.dialogRef.close({username, password});
    }
  }

  togglePasswordIcon(){
    this.fieldTextType = !this.fieldTextType
  }

  redirectToVmIP(){
    let url;
    if (!this.data.depName && !this.data.headNodeIp) {
      let webHost = this.env.envVariables.webHost;
      if (this.env.envVariables.webHost?.indexOf(":") != -1) {
        webHost = this.env.envVariables.webHost.split(":")[0];
      }
      else {
        webHost = this.env.envVariables.webHost.split("/")[0];
      }
      url = `${this.env.envVariables.httpProtocol}${webHost}:${this.env.envVariables.UtilityAccessPort}/authorize`;
    } else {
      url = this.deploymentService.getUrlForUtilityService(this.data.depName, this.data.headNodeIp, this.env.envVariables.UtilityAccessPort, 0, this.utilityType);
    }
    window.open(url, "_blank")
  }

}
